import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../utils/api';

const ChangePasswordPage = () => {
  const { t } = useTranslation();
  const { user, updateUser, logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ newPassword: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.newPassword !== form.confirmPassword) {
      setError(t('auth.password') + ' ne correspondent pas');
      return;
    }
    if (form.newPassword.length < 8) {
      setError('Le mot de passe doit avoir au moins 8 caractères');
      return;
    }
    setLoading(true);
    try {
      await authAPI.changePassword({ newPassword: form.newPassword });
      updateUser({ mustChangePassword: false });
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || t('common.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-box">
          <div className="login-logo">
            <div className="login-logo-icon">🔐</div>
            <h1>{t('auth.changePassword')}</h1>
            <p>{t('auth.mustChangePassword')}</p>
          </div>

          {error && <div className="alert alert-error">⚠ {error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">{t('auth.newPassword')}</label>
              <input
                type="password"
                className="form-input"
                value={form.newPassword}
                onChange={e => setForm(f => ({ ...f, newPassword: e.target.value }))}
                required minLength={8}
                placeholder="Minimum 8 caractères"
              />
            </div>
            <div className="form-group">
              <label className="form-label">{t('auth.confirmPassword')}</label>
              <input
                type="password"
                className="form-input"
                value={form.confirmPassword}
                onChange={e => setForm(f => ({ ...f, confirmPassword: e.target.value }))}
                required minLength={8}
                placeholder="Répétez le mot de passe"
              />
            </div>
            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
              {loading ? t('common.loading') : t('common.save')}
            </button>
          </form>

          <button
            style={{ width: '100%', marginTop: 12, background: 'none', border: 'none', color: 'var(--gray-500)', cursor: 'pointer', fontSize: 13 }}
            onClick={logout}
          >
            {t('nav.logout')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
